import { render, staticRenderFns } from "./DiagnosticAnswer.vue?vue&type=template&id=14f1398e&scoped=true"
import script from "./DiagnosticAnswer.vue?vue&type=script&lang=js"
export * from "./DiagnosticAnswer.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticAnswer.vue?vue&type=style&index=0&id=14f1398e&prod&lang=scss"
import style1 from "./DiagnosticAnswer.vue?vue&type=style&index=1&id=14f1398e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f1398e",
  null
  
)

export default component.exports